export default {
    data() {
        return {
            textarea: '',
            // 查询回复url
            searchUrl: 'answ_question_comment/search',
            // 新增回复url
            createUrl: 'answ_question_comment/create',
            // 查询答疑url
            answQuestionUrl: 'answ_question/search',
            // 当前点击答疑列表项
            question: {},
            // 用户id
            user_id: null,
            // 班级id
            class_id: '',
            name: '',
            // 回复列表
            comments: [],
            // 辅导员回复列表  
            comments2: [],
            // 总条数
            total: 1,
            // 当前页
            currentPage: 1,
            // 起始位置
            offset: 0,
            // 返回条数
            length: 10,
            // 页面跳转传递id
            id: '',
            //项目详情
            classDetails: {},
            // 订单项id
            purchased_id: null,
            // 问题id
            answ_question_id: null,
            // 加载状态
            loading: false
        }
    },

    methods: {
        backRouter() {
            this.$router.go(-1)
        },
        // 发表
        handleSubmit() {
            // // console.log(this.answ_question_id);
            const { textarea, createUrl } = this
            if (!textarea) {
                this.$message({
                    message: '请填写你要发表的内容',
                    type: 'error'
                });
                this.textarea = ''
                return
            }
            const data = {
                token: this.$store.state.id,
                answ_question_id: this.answ_question_id,
                content: textarea,
                class_id: this.class_id
            }
            this.$post(createUrl, data).then(res => {
                // // console.log(res)
                if (res.status === 200) {
                    const comment = {
                        name: this.name,
                        content: textarea,
                        created_at: this.dateFormat(new Date())
                    }
                    this.getComment()
                    // // console.log('-------------')
                    // // console.log(this.comments)
                }
            })
            this.textarea = ''
            this.page(this.class_id)
        },

        dateFormat(date) {
            const year = date.getFullYear()
            const month = this.addZero(date.getMonth() + 1)
            const day = this.addZero(date.getDate())
            const hour = this.addZero(date.getHours())
            const minute = this.addZero(date.getMinutes())
            const second = this.addZero(date.getSeconds())
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
        },

        addZero(number) {
            if (number < 9) {
                return '0' + number
            } else {
                return number
            }
        },

        // pageSize 改变时会触发
        handleSizeChange(val) {
            this.length = val
            this.page(this.class_id)
        },

        // currentPage 改变时会触发
        handleCurrentChange(val) {
            const offset = (val - 1) * this.length
            this.offset = offset
            this.page(this.class_id)
        },

        // 分页
        page(class_id) {
            // // console.log('class_id = ' + class_id)
            const data = {
                token: this.$store.state.id,
                offset: this.offset,
                length: this.length,
                answ_question_id: this.answ_question_id,
                class_id: class_id
            }
            this.$post(this.searchUrl, data).then(res => {
                // // console.log(res)
                const data = res.data.result.data
                this.total = res.data.result.total
                this.comments = data
                // // console.log(this.comments)
            })
        },

        //获取班级信息
        // getClassinformation() {
        //   this.$post('class_users/get_class_by_purchased_id', {
        //     token: this.$store.state.id,
        //     offset: 0,
        //     length: 9999,
        //     purchased_id: this.purchased_id
        //   })
        //     .then(res => {
        //       this.class_id = res.data.result.id
        //       this.page(this.class_id)
        //       // // console.log('进来了')
        //     })
        // },

        getComment() {
            this.loading = true
            this.$post('answ_question_comment/search', {
                token: this.$store.state.id,
                answ_question_id: this.answ_question_id,
                class_id: this.class_id,
                offset: this.offset,
                length: this.length
            }).then(res => {
                // console.log('res', res)
                this.total = res.data.result.total
                this.comments = res.data.result.data
                this.loading = false
            })
        },

        getCommentByInstructor() {
            this.$post('class/get', {
                token: this.$store.state.id,
                id: this.class_id
            }).then(res => {
                let instructorId = res.data.result.instructor_id
                this.$post('instructor_reply/search', {
                    answ_question_id: this.answ_question_id,
                    instructor_id: instructorId,
                    class_id: this.class_id,
                    offset: 0,
                    length: 999
                }).then(res2 => {
                    this.comments2 = res2.data.result.data
                })
            })
        }
    },
    mounted() {
        this.purchased_id = this.$route.query.purchased_id
        this.user_id = this.$store.state.userId
        this.question = this.$route.query.post
        this.answ_question_id = this.question.id
        this.name = this.$store.state.name
        this.class_id = this.$route.query.class_id
        // // console.log('this.purchased_id = ' + this.purchased_id)
        // // console.log('this.user_id = ' + this.user_id)
        // // console.log('this.question = ' + this.question)
        // // console.log('this.answ_question_id = ' + this.answ_question_id)
        // // console.log('this.name = ' + this.name)
        // this.getClassinformation()
        this.getComment()
        this.getCommentByInstructor()
        this.page(this.class_id)
    }
}